import React from 'react';
import img from '../images/web.svg';
import img2 from '../images/app.svg';
import img3 from '../images/hosting.svg';
import img4 from '../images/consultation.svg';

const Services = () => {

    return (
        <div id="services" className="bg-gray-100 py-12" >
            <section data-aos="zoom-in-down">
                <div className="my-4 py-4">
                    <h2 className="my-2 text-center text-3xl text-blue-900 uppercase font-bold">services</h2>

                    <div className='flex justify-center'>
                        <div className='w-24 border-b-4 border-blue-900'></div>
                    </div>
                    <h2 className="mt-4 mx-12 text-center text-xl lg:text-2xl font-semibold text-blue-900">We are deeply committed to the growth and success of our clients.</h2>
                </div>

                <div className="px-12" data-aos="fade-down" data-aos-delay="600">
                    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">

                        <div className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-gray-700 rounded-lg shadow-2xl p-3 group">
                            <div className="m-2 text-justify text-sm">
                                <img alt="card img" className="rounded-t " style={{ width: '100%' }} src='/service01.png' />
                                <h2 className="font-semibold my-4 text-2xl text-center">Product Analysis</h2>
                                <p className="text-md font-medium">
                                    Continuously analyze and track hot selling products in the market, provide product recommendations to suppliers, and help them improve sales performance.
                                </p>
                            </div>
                        </div>

                        <div className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-gray-700  rounded-lg shadow-2xl p-3 group">
                            <div className="m-2 text-justify text-sm">
                                <img alt="card img" className="rounded-t " style={{ width: '100%' }} src='/service02.png' />
                                <h2 className="font-semibold my-4 text-2xl text-center">Order Review</h2>
                                <p className="text-md font-medium">
                                    With an accuracy rate of over 99.9% for orders, we effectively control order dispute rates and provide rating protection for your store.
                                </p>
                            </div>
                        </div>

                        <div className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-gray-700  rounded-lg shadow-2xl p-3 group">
                            <div className="m-2 text-justify text-sm">
                                <img alt="card img" className="rounded-t" style={{ width: '100%' }} src='/service03.png' />
                                <h2 className="font-semibold my-4 text-2xl text-center ">On Time</h2>
                                <p className="text-md font-medium">
                                    Always maintain on-time delivery rate, 99.99% of goods meet the 24-hour outbound standard, and are delivered to the final logistics service provider.
                                </p>
                            </div>
                        </div>

                        <div className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-gray-700  rounded-lg shadow-2xl p-3 group">
                            <div className="m-2 text-justify text-sm">
                                <img alt="card img" className="rounded-t" style={{ width: '100%' }} src='/service04.png' />
                                <h2 className="font-semibold my-4 text-2xl text-center ">Customer Service</h2>
                                <p className="text-md font-medium">
                                    High quality customer service teams from China and the United States are available 24/7 to assist you and resolve your issues as quickly as possible.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="m-auto max-w-6xl p-2 md:p-12 h-5/6">
                    <div className="my-4 py-4">
                        <h2 className="my-2 text-center text-3xl text-blue-900 uppercase font-bold">Platforms</h2>

                        <div className='flex justify-center'>
                            <div className='w-24 border-b-4 border-blue-900'></div>
                        </div>

                    </div>
                    <div className="flex flex-row py-8  " data-aos="zoom-out">
                        <div className="sm:w-1/2 lg:w-1/2 flex flex-col lg:mx-4 justify-center text-center">
                            <img src='/platforms/amazon.png'></img>
                        </div>
                        <div className="sm:w-1/2 lg:w-1/2 flex flex-col lg:mx-4 justify-center text-center">

                            <img src='/platforms/tiktok.png'></img>
                        </div>
                        <div className="sm:w-1/2 lg:w-1/2 flex flex-col lg:mx-4 justify-center text-center">

                            <img src='/platforms/temu.png'></img>
                        </div>
                        <div className="sm:w-1/2 lg:w-1/2 flex flex-col lg:mx-4 justify-center text-center">

                            <img src='/platforms/shein.png'></img>
                        </div>
                        <div className="sm:w-1/2  lg:w-1/2 flex flex-col lg:mx-4 justify-center text-center">

                            <img src='/platforms/walmart.png'></img>
                        </div>
                        <div className="sm:w-1/2 lg:w-1/2 flex flex-col lg:mx-4 justify-center text-center">

                            <img src='/platforms/shopify.png'></img>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Services;